<template>
  <div>
    <div class="img-container">
      <img v-if="languages.lan==='cn'"
           src="~/assets/pics/ServiceCenterCn.png"
           alt="" />
      <img v-else
           src="~/assets/pics/ServiceCenterEn.png"
           alt="" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { ubtRegister } from 'utils/ubt';

export default {
  computed: {
    ...mapState([
      'languages',
    ]),
  },
  methods: {
    ...mapMutations([
      'setPageNow',
      'setHomeHidden',
      'setSearchHidden',
    ]),
  },
  created () {
    this.setPageNow('ServiceCenter');
    this.setHomeHidden(false);
    ubtRegister('IT Service Center');
  },
};
</script>

<style lang="scss" scoped>
.img-container {
  // margin: 10px;
  position: absolute;
  left: 10px;
  right: 10px;
  top: 80px;
  bottom: 10px;
  // border: 1px solid #000;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
